import axios from 'axios';
import {errors as E} from 'common/constants/errors';

export const GET_LIST = 'appraisals/getList';
export const GET_FILE = '';
export const GET_CITIES = 'generalData/getAppraisalCities';
export const GET_STREETS = 'generalData/getAppraisalStreetsByCity';

export const getList = async (request) => {
  try {
    const response = await axios.post(GET_LIST, request);

    const {body, errorCode} = response.data;

    if (errorCode < 0) {
      throw new Error(E.SERVER_ERROR);
    }

    const {
      list,
      totalPageCount,
      currentPageNumber,
      totalResultCount,
    } = body;

    return {
      list,
      totalPageCount,
      currentPageNumber,
      totalResultCount,
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getFile = async (id) => {
  try {
    const response = await axios.post(GET_FILE, id);

    const {body, errorCode} = response.data;

    if (errorCode < 0) {
      throw new Error(E.SERVER_ERROR);
    }

    return body?.data?.link ?? '';
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getAppraisalCities = async () => {
  try {
    const response = await axios.get(GET_CITIES);

    const {body, errorCode} = response.data;

    if (errorCode < 0) {
      throw new Error(E.SERVER_ERROR);
    }

    return body?.cities ?? [];
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const getAppraisalStreets = async (city) => {
  try {
    const response = await axios.get(GET_STREETS, {
      params: { city }
    });

    const { body, errorCode } = response.data;

    if (errorCode < 0) {
      throw new Error(E.SERVER_ERROR);
    }

    return body?.streets ?? [];
  } catch (e) {
    console.error(e);
    throw e;
  }
};